import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { AppLoading } from '../../../../../../loaders/loaders';
import DriverCommentsDataGrid from './DriverCommentsDataGrid';
import styles from './styles';
import { DriverComment } from './constants';

type DriverCommentsProps = {
  classes: Record<string, string>;
  driverComments?: DriverComment[] | null;
  isLoading?: boolean;
};

const DriverComments = ({ classes, driverComments, isLoading }: DriverCommentsProps) => {
  if (isLoading) {
    return <AppLoading />;
  }

  return <DriverCommentsDataGrid classes={classes} driverComments={driverComments ?? []} />;
};

export default compose(withStyles(styles))(DriverComments);
